<template>
  <div class="km__modules__lieferanfrage km__popup">
    <div class="km__popup--heading">
      <h2>{{ $t("konf_form_header") }}</h2>
    </div>
    <div class="km__popup--content">
      <p v-html="$t('konf_SupportNeeded')"></p>
      <BasicContactForm @close="closePopup" @send="send"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BasicContactForm from "@km/components/popups/BasicContactForm.vue";
import {useStore} from "vuex";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {getHelpAnfrageParameters, sendGetHelpForm} from "@km/mixins/sendGetHelpForm";
import {useI18n} from "vue-i18n";
import type {BasicContactFormData} from "@km/components/popups/BasicContactFormData";


const store = useStore();
const i18n = useI18n();
const closePopup = () => store.commit("SET_OVERLAY_CLOSED", OverlayNames.lieferzeitAnfrage);


const send = (formdata: BasicContactFormData) => {
  sendGetHelpForm(getHelpAnfrageParameters(formdata, "Kontaktanfrage", "Lieferzeitpunkt"), store, i18n)
      .then(() => closePopup())
};

</script>

<style scoped lang="scss">
.km__modules__lieferanfrage {
  z-index: 999;
  overflow-y: scroll;

  .km__input--standard,
  .km__input--area {
    margin-bottom: 15px;
  }

  :deep(strong) {
    font-weight: bold;
  }
}
</style>
